export default "/images/5e026326c1b0098d839f967bac7fef9d.avif";